import React from "react";
import useUploader from "./useUploader";

const Uploader = React.forwardRef((props, ref) => {
  const { onUploadStart, ...other } = props;
  const uploadInputRef = React.useRef();

  React.useImperativeHandle(
    ref,
    () => ({
      click: () => {
        uploadInputRef.current.click();
      },
    }),
    [props, ref, uploadInputRef]
  );

  const handleStart = (file, next) => {
    onUploadStart && onUploadStart(file);

    next(file);
  };

  useUploader({ ...other, onUploadStart: handleStart }, uploadInputRef);

  return (
    <input
      type="file"
      style={{
        visibility: "hidden",
        width: "100%",
        height: "100%",
        position: "absolute",
      }}
      ref={uploadInputRef}
    />
  );
});

export default Uploader;
